<script setup lang="ts">
// Bottom treeline band of pines — ported from context.jsx.
import { computed } from 'vue'
import { BK } from '../tokens'
import Pine from './PineTree.vue'

const props = withDefaults(
  defineProps<{ color?: string; h?: number }>(),
  { color: BK.pineDeep, h: 96 },
)

const pines = Array.from({ length: 26 }, (_, i) => i)
const bandStyle = computed(() => ({ height: `${props.h}px`, background: props.color }))
const rowStyle = computed(() => ({ bottom: `${props.h - 4}px` }))
</script>

<template>
  <div class="treeline" :style="bandStyle">
    <div class="treeline__row" :style="rowStyle">
      <Pine
        v-for="i in pines"
        :key="i"
        :size="26 + (i % 4) * 12"
        :fill="color"
        :trunk="color"
      />
    </div>
  </div>
</template>

<style scoped>
.treeline {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
.treeline__row {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 10px;
}
</style>
